export class PortalContent {

  companyId: number | undefined;
  userId: string | undefined;
  aboutUsContent: string = '';
  referralContent: string | undefined;
  showReferralTerms: boolean | undefined;
  referralTermsContent: string | undefined;
  showPrequalLetterGeneration: boolean | undefined;
  browserTabTitleText: string;
  readonly allowRecipientsToSignInAnyOrder: boolean | null;
  readonly doNotEnforceChronologicalOrderInEsignTasks: boolean | null;
  readonly isGoogleAddressesIntegrationDisabled: boolean | null;
  readonly isGoogleStreetViewImageDisabled: boolean | null;
  readonly isAssetVerificationLoanActionEnabled : boolean | null;
  readonly isMortgageCalculatorLoanActionEnabled : boolean | null;
  readonly isEmploymentIncomeVerificationLoanActionEnabled : boolean | null;
  readonly isUploadingAdditionalDocumentsLoanActionEnabled : boolean | null;
  readonly isPreApprovalLetterGenerationLoanActionEnabled : boolean | null;
  readonly isBulkUploadEnabled : boolean | null;

  footerDisclosureHtml: string | undefined;
  enableSpanishToggle: boolean | undefined;
  spanishToggleNotice: string | undefined;
  companyName: string | undefined;
  companyNmls: string | undefined;
  companyAddress: string | undefined;
  companyCity: string | undefined;
  companyState: string | undefined;
  companyZip: string | undefined;

  constructor() {
  }
}

